export default __webpack_public_path__ + "static/media/logo.4c06f957.svg";